export default function ItemReviewCard({ review }) {
  return (
    <div className="min-w-[85%] sm:min-w-[45%] md:min-w-[30%] lg:min-w-[23%] flex-shrink-0 snap-start bg-white rounded-2xl shadow p-4">
      {/* Image (placeholder or first image) */}
      <div className="relative w-full h-40 overflow-hidden rounded-xl mb-3">
        {review.imagePath?.length ? (
          <img
            src={review.imagePath[0]}
            alt="review"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="flex items-center justify-center w-full h-full bg-gray-100 text-gray-400">
            No Image
          </div>
        )}
      </div>

      {/* Star Rating */}
      <div className="flex items-center mb-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <svg
            key={i}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill={i < (review.rating || 0) ? "gold" : "lightgray"}
            className="w-5 h-5"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.18 3.63a1 1 0 00.95.69h3.812c.969 0 1.372 1.24.588 1.81l-3.09 2.245a1 1 0 00-.364 1.118l1.18 3.63c.3.921-.755 1.688-1.54 1.118l-3.09-2.245a1 1 0 00-1.175 0l-3.09 2.245c-.785.57-1.84-.197-1.54-1.118l1.18-3.63a1 1 0 00-.364-1.118L2.52 9.057c-.783-.57-.38-1.81.588-1.81h3.812a1 1 0 00.95-.69l1.18-3.63z" />
          </svg>
        ))}
      </div>

      {/* Company Name */}
      <h3 className="font-medium text-gray-900">
        {review.companyName || "Anonymous"}
      </h3>

      {/* Description */}
      <p className="text-sm text-gray-600 mt-1 line-clamp-3">
        {review.description || "No description provided."}
      </p>

      {/* Posted Date */}
      <p className="text-xs text-gray-400 mt-3">
        {review.createdAt
          ? new Date(review.createdAt.seconds * 1000).toLocaleDateString()
          : "Unknown date"}
      </p>
    </div>
  );
}
